import {FC, ReactNode} from "react";

const Note: FC<{ header?: string, body: ReactNode }> = ({header = "Note", body}) => {
  return <div className="note-container">
    <p className="header">{header}</p>
    {body}
    <style jsx>{`
      .note-container {
        padding: 0 15px;
        border-bottom: #000 1px dotted;
        border-top: #000 1px dotted;
      }

      .header {
        font-weight: 500;
      }
    `}</style>
  </div>
}

export default Note;
